<template>
  <div class="scales">

    <div id="scale-card-container" v-if="store.getScalesCount() > 0">
      <scale-card v-for="scale in store.state.scales" v-bind:key="scale.id" :scale="scale" />
    </div>

    <div id="no-scales-info" v-else>
      <p>
        You have no scales added yet.
        <br />Please consider adding one.
      </p>
    </div>

    <router-link
      :to="{name: 'scales.create'}"
      tag="button"
      type="button"
      id="measurement-create-button"
      class="btn btn-primary"
    >+ New scale</router-link>
  </div>
</template>

<script>
import { store } from "@/store.js";
import ScaleCard from "@/components/ScaleCard.vue";

export default {
  name: "ScalesView",
  components: {
    ScaleCard
  },
  data: function() {
    return {
      store: store
    };
  },
  computed: {},
  created: function() {
    console.log("Scales view created...");
    store.fetchScales();
  },
  methods: {}
};
</script>

<style scoped>
#scale-card-container {
  padding-top: 1rem;
}

#no-scales-info {
  font-size: 140%;
}
</style>
